import { __extends } from "tslib";
import ABaseNative from './native.base';
var AndroidNative = /** @class */ (function (_super) {
    __extends(AndroidNative, _super);
    function AndroidNative() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AndroidNative.prototype.getCallHandler = function (target, method) {
        var _a;
        var handler = ((_a = window === null || window === void 0 ? void 0 : window[target]) === null || _a === void 0 ? void 0 : _a[method]) || null;
        if (!handler)
            throw new Error("no bridge api[".concat(target, ".").concat(method, "]"));
        handler = handler.bind(window[target]);
        return function (callbackId, params) {
            if (params && typeof params !== 'string') {
                params = JSON.stringify(params);
            }
            handler(params ? params : undefined, callbackId);
        };
    };
    return AndroidNative;
}(ABaseNative));
export default AndroidNative;
